import { FlattenedObject } from "../models/Po";

export type EvaluateFunction = (p: FlattenedObject) => boolean;

export interface Recipe {
  mach_code: string;
  recipe_id: number;
  recipe_name: string;
  evaluateFn: EvaluateFunction;
  cycle_tile: number;
}

export function getMatchingRecipeIds(p: FlattenedObject): Recipe[] {
  const matchingRecipes: Recipe[] = [];
  for (const recipe of recipes) {
    if (recipe.evaluateFn(p)) {
      matchingRecipes.push(recipe);
    }
  }
  return matchingRecipes;
}

/* 以下メンテナンスが必要なレシピ照合用プログラム */
export const recipes: Recipe[] = [
  // FCR: 546
  // 板厚 3mm
  {
    mach_code: "546",
    recipe_id: 99,
    recipe_name: "TTH3.2-X2",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("TTH3.2") &&
        p.thickness === 3.2 &&
        800 * 800 <= area &&
        area < 900 * 1800 &&
        100 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 192.9,
  },
  // 板厚 4mm
  {
    mach_code: "546",
    recipe_id: 108,
    recipe_name: "PT4-HMF",
    evaluateFn: (p: FlattenedObject) => {
      return p.product_name.includes("HM") && p.thickness === 4;
    },
    cycle_tile: 238.4,
  },
  {
    mach_code: "546",
    recipe_id: 50,
    recipe_name: "PT4-X3",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 4 &&
        300 * 100 <= area &&
        area < 800 * 800 &&
        10 <= short &&
        short < 900 &&
        long < 4800
      );
    },
    cycle_tile: 224.6,
  },
  {
    mach_code: "546",
    recipe_id: 126,
    recipe_name: "PT4X1yoF",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;

      return p.thickness === 4 && 900 * 1800 <= area && 900 <= short;
    },
    cycle_tile: 252.4,
  },
  {
    mach_code: "546",
    recipe_id: 61,
    recipe_name: "PT4X2F",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 4 &&
        800 * 800 <= area &&
        area < 900 * 1800 &&
        100 <= short &&
        short < 900
      );
    },
    cycle_tile: 255.5,
  },
  // 板厚 5mm
  {
    mach_code: "546",
    recipe_id: 182,
    recipe_name: "PT5900x2100tate4maiF",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        700 * 1900 <= area &&
        area < 1100 * 2300 &&
        700 <= short &&
        short < 1100 &&
        long <= 2300
      );
    },
    cycle_tile: 325.5,
  },
  {
    mach_code: "546",
    recipe_id: 83,
    recipe_name: "PT5HosonagaF",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        10 * 1500 <= area &&
        area < 300 * 2000 &&
        300 <= short &&
        1500 <= long &&
        long < 2000
      );
    },
    cycle_tile: 272.3,
  },
  {
    mach_code: "546",
    recipe_id: 85,
    recipe_name: "PT5X1F",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        900 * 1800 <= area &&
        900 <= short &&
        long <= 4800
      );
    },
    cycle_tile: 315.5,
  },
  {
    mach_code: "546",
    recipe_id: 84,
    recipe_name: "PT5X2F",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        800 * 800 <= area &&
        area <= 900 * 1800 &&
        100 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 301.5,
  },
  {
    mach_code: "546",
    recipe_id: 111,
    recipe_name: "PT5X3F",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        300 * 100 <= area &&
        area <= 800 * 800 &&
        10 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 262.3,
  },
  {
    mach_code: "546",
    recipe_id: 134,
    recipe_name: "PT5X1yokoF",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        900 * 1800 <= area &&
        900 <= short &&
        long <= 4800
      );
    },
    cycle_tile: 315.5,
  },
  {
    mach_code: "546",
    recipe_id: 111,
    recipe_name: "PT5X3F",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT5") &&
        p.thickness === 5 &&
        300 * 100 <= area &&
        area <= 800 * 800 &&
        10 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 262.3,
  },
  // 板厚 6mm
  {
    mach_code: "546",
    recipe_id: 158,
    recipe_name: "PT6-1800x2300.FR3",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT6") &&
        p.thickness === 6 &&
        1600 * 2100 <= area &&
        area <= 2000 * 2500 &&
        1600 <= short &&
        short < 2000 &&
        long <= 2500
      );
    },
    cycle_tile: 373.8,
  },
  {
    mach_code: "546",
    recipe_id: 180,
    recipe_name: "PT6.1800x1800,1mai.FR4",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT6") &&
        p.thickness === 6 &&
        1600 * 1600 <= area &&
        area <= 2000 * 2000 &&
        1600 <= short &&
        short < 2000 &&
        long <= 2000
      );
    },
    cycle_tile: 368.8,
  },
  {
    mach_code: "546",
    recipe_id: 114,
    recipe_name: "PT6smallF",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.product_name.includes("PT6") &&
        p.thickness === 6 &&
        300 * 100 <= area &&
        area <= 800 * 800 &&
        10 <= short &&
        short < 900 &&
        long <= 2000
      );
    },
    cycle_tile: 363.1,
  },
  // RC: 545
  {
    mach_code: "545",
    recipe_id: 765,
    recipe_name: "PT8-M.R2",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 8 &&
        800 * 800 <= area &&
        area < 900 * 1800 &&
        100 <= short &&
        short < 900
      );
    },
    cycle_tile: 270,
  },
  {
    mach_code: "545",
    recipe_id: 353,
    recipe_name: "PT6-2100x2200tate1mai",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("PT6") &&
        1900 * 2000 <= area &&
        area < 2300 * 2400 &&
        1900 <= short &&
        short < 2600 &&
        long < 2500
      );
    },
    cycle_tile: 225,
  },
  {
    mach_code: "545",
    recipe_id: 317,
    recipe_name: "PT6-900x27002mai",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("PT6") &&
        700 * 2500 <= area &&
        area < 1100 * 2900 &&
        700 <= short &&
        short < 1100 &&
        long < 3000
      );
    },
    cycle_tile: 210,
  },
  {
    mach_code: "545",
    recipe_id: 752,
    recipe_name: "PT6-L-yoko.R2",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("PT6") &&
        900 * 1800 <= area &&
        area < 2400 * 4800 &&
        900 <= short &&
        long <= 4800
      );
    },
    cycle_tile: 230,
  },
  {
    mach_code: "545",
    recipe_id: 759,
    recipe_name: "PT6-M.R2",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("PT6") &&
        800 * 800 <= area &&
        area < 900 * 1800 &&
        100 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 230,
  },
  {
    mach_code: "545",
    recipe_id: 762,
    recipe_name: "PT6-S.R2",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("PT6") &&
        300 * 100 <= area &&
        area < 800 * 800 &&
        10 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 195,
  },
  {
    mach_code: "545",
    recipe_id: 796,
    recipe_name: "HS6-M.R3",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("HS6") &&
        800 * 800 <= area &&
        area < 900 * 1800 &&
        100 <= short &&
        short < 900 &&
        long <= 4800
      );
    },
    cycle_tile: 535,
  },
  {
    mach_code: "545",
    recipe_id: 795,
    recipe_name: "HS6-1200x27001mai.R3",
    evaluateFn: (p: FlattenedObject) => {
      const short = Math.min(p.po_width, p.po_height);
      const long = Math.max(p.po_width, p.po_height);
      const area = p.po_width * p.po_height;
      return (
        p.thickness === 6 &&
        p.product_name.includes("HS6") &&
        1000 * 2500 <= area &&
        area < 1400 * 2900 &&
        1000 <= short &&
        short < 1400 &&
        long <= 2900
      );
    },
    cycle_tile: 530,
  },
];
